import { SignInButton, SignUpButton } from '@clerk/clerk-react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { useEffect } from 'react';

import { Unauthenticated } from 'convex/react';
import { useConvexAuth } from 'convex/react';

import wcCash from '@/assets/images/wc-cash.svg';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

function HomePage() {
  const { isAuthenticated, isLoading } = useConvexAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      navigate({ to: '/balance-sheets', params: {} });
    }
  }, [isLoading, isAuthenticated, navigate]);

  if (isLoading) {
    return (
      <div className="container mx-auto">
        <div className="flex items-center justify-center h-[calc(100vh-10rem)] w-full">
          <Skeleton className="h-60 w-80 rounded-xl" />
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto">
      <Unauthenticated>
        <div className="flex flex-col items-center justify-center h-[calc(100vh-10rem)]">
          <Card className="w-full max-w-sm">
            <CardContent className="pt-8 pb-8 flex flex-col items-center text-center">
              <img src={wcCash} alt="WealthyCub" className="h-40 w-40 mb-1" />
              <h1 className="text-3xl font-bold mb-1">WealthyCub</h1>
              <p className="text-muted-foreground mb-8 italic">
                "I checked my bank account. It did not scare me. Success."
              </p>
              <div className="flex gap-3">
                <SignInButton mode="modal">
                  <Button variant="outline">Sign In</Button>
                </SignInButton>
                <SignUpButton mode="modal">
                  <Button>Sign Up</Button>
                </SignUpButton>
              </div>
            </CardContent>
          </Card>
        </div>
      </Unauthenticated>
    </div>
  );
}

export const Route = createFileRoute('/')({
  component: HomePage,
});
